import PokemonInfo from "./PokemonInfo";

export default PokemonInfo;
